<div style="float:left; width: 100%; height: calc(100% - 100px);">
  <jqxGrid #gridTarjetas [theme]="environment.tema" [width]="'100%'" [height]="'100%'" [source]="dataAdapterTarjetas"
    [columnsresize]="true" [filterable]="false" [showfilterrow]="false" [columns]="columnsTarjetas" [sortable]="false"
    [altrows]="true" [showrowlines]="false" [filterrowheight]="30" [rowsheight]="25" [columnsheight]="25"
    [showaggregates]="false" [showstatusbar]="false" [statusbarheight]="20" [localization]="langGrid">
  </jqxGrid>
</div>
